export default __webpack_public_path__ + "static/media/dummy.fff222c6.png";